export default {
  signIn: 'Přihlásit se',
  signOut: 'Odhlásit se',
  points: 'body',
  hyattSignInButton: 'Přihlaste se do World of Hyatt',
};
